import Style from "./CategoriesTableStyle";
import Spinner from "../../shared/Spinner/Spinner";
import TwoButtonsModal from "../../shared/Bootstrap/TwoButtonsModal";
import api from "../../services/api";

import { FaTrashAlt } from "react-icons/fa";
import React, { useEffect, useState } from "react";
import PageTitle from "../../components/PageTitle";
import { GetFileFromURL } from "../../utils";

export default function CategoriesTable(props) {
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");

  const [categories, setCategories] = useState([] as any);

  const [deletingCategory, setDeletingCategory] = useState(false);
  const [categoryToDelete, setCategoryToDelete] = useState({} as any);


  useEffect(() => {
    LoadCategories();
  }, []);

  async function LoadCategories() {
    try {
      setLoading(true);
      const result = await api.get(`productsCategories`);
      if (result.data.success) {
        const categories = result.data.allCategories;
        setCategories(categories);
        setErrorMessage("");
      }
      else
        setErrorMessage("Não foi possível consultar as categorias: " + result.data.message)
    }
    catch (error: any) {
      setErrorMessage(error.response?.data?.message || "Erro carregando categorias");
    }
    finally {
      setLoading(false);
    }
  }


  async function DeleteCategory() {
    setDeletingCategory(true);
    try {
      const result = await api.delete(`/productsCategories/${categoryToDelete.id}`);
      if (!result.data.success) {
        setErrorMessage("Não foi possível deletar categoria");
      }
      await LoadCategories();
      setDeletingCategory(false);
      ClosePopupDeletingCategory();
    }
    catch (error) {
      await LoadCategories();
      setDeletingCategory(false);
      ClosePopupDeletingCategory();
    }
  }

  function ClosePopupDeletingCategory() {
    setCategoryToDelete({});
  }

  function GoToCategory(categoryId: number) {
    props.history.push(`/categories/${categoryId}`);
  }

  function GetImageUrl(imageURL, categoryId): string {
    return GetFileFromURL(imageURL, `${process.env.REACT_APP_BASE_URL}/productsCategories/${categoryId}/image`);
  }

  return (
    <Style>
      <PageTitle title="Categorias" />
      <TwoButtonsModal
        show={categoryToDelete.id != null}
        onHide={ClosePopupDeletingCategory}
        loading={deletingCategory}
        title="Deleção de categoria!"
        body={`Você está tentando deletar a categoria "${categoryToDelete.category}", essa ação é irreversível!`}
        secondaryText="Fechar"
        secondaryOnClick={ClosePopupDeletingCategory}
        secondaryDisabled={deletingCategory}
        primaryText="Deletar"
        primaryOnClick={DeleteCategory}
        primaryDisabled={deletingCategory}
      />
      {errorMessage !== "" && <p className="alert alert-error">Erro: {errorMessage}</p>}
      <Spinner spinning={loading} />

      <section className="table-title">
        <h1>Categorias</h1>
        <button onClick={() => GoToCategory(0)}>Adicionar Categoria</button>
      </section>


      <table className="table table-striped table-bordered table-hover">
        <thead >
          <tr>
            <th>Categoria</th>
            <th>Ícone</th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody>
          {categories?.length > 0 && categories.map(category => {
            return (
              <tr key={category.category}>
                <td onClick={() => GoToCategory(category.id)} className="clickable">{category.category}</td>
                <td onClick={() => GoToCategory(category.id)}>
                  {category?.iconUrl ?
                    <img
                      src={GetImageUrl(category.iconUrl, category.id)}
                      alt="Imagem da Categoria"
                      className="imagePreview"
                    /> :
                    <p>Sem imagem</p>}
                </td>
                <td className="action">
                  <button
                    onClick={() => setCategoryToDelete(category)}
                  ><FaTrashAlt className="icon" /></button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </Style>

  )
}